<template>
    <b-card class="shadow-none">
        <div>
        <h6>新密碼</h6>
        <textboxVue type="password"></textboxVue>
        <h6>重複新密碼</h6>
        <textboxVue type="password"></textboxVue>
        <b-button variant="danger" class="f-right">
            確定
        </b-button>
    </div>
    </b-card>
    
</template>

<script>
import textboxVue from '../../../components/form/textbox.vue';
export default {
    components: {
        textboxVue
    }
}

</script>